import {NgModule, ModuleWithProviders} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';
import {TextMaskModule} from 'angular2-text-mask';

import {AlertComponent} from './alert/alert.component';
import {AlertService} from './alert/alert.service';
import {BaseFillDataFormComponent} from './form-section/base-fill-data-form-component';
import {FormSectionComponent} from './form-section/form-section.component';
import {FormSectionItemComponent} from './form-section/form-section-item/form-section-item.component';
import {InputComponent} from './form-section/input/input.component';
import {LabelCheckboxComponent} from './form-section/label-checkbox/label-checkbox.component';
import {LabelDropdownComponent} from './form-section/label-dropdown/label-dropdown.component';
import {LabelInputComponent} from './form-section/label-input/label-input.component';
import {LabelListComponent} from './form-section/label-list/label-list.component';
import {LabelRadioInputComponent} from './form-section/label-radio-input/label-radio-input.component';
import {LabelStarRatingComponent} from './form-section/label-star-rating/label-star-rating.component';
import {LabelTextareaComponent} from './form-section/label-textarea/label-textarea.component';
import {PageNavigationComponent} from './page-navigation/page-navigation.component';
import {SalaryInputComponent} from './form-section/salary-input/salary-input.component';
import {ValidationAlertComponent} from './validation-alert/validation-alert.component';
import {WebsiteUserInputComponent} from './form-section/website-user-input/website-user-input.component';
import {SharedModule} from '../shared/shared.module';
import {ScrollComponent} from './scroll/scroll.component';
import {SalaryRangeInputComponent} from '@widgets/form-section/salary-range-input/salary-range-input.component';

const COMPONENTS = [
  AlertComponent,
  BaseFillDataFormComponent,
  FormSectionComponent,
  FormSectionItemComponent,
  InputComponent,
  LabelCheckboxComponent,
  LabelDropdownComponent,
  LabelInputComponent,
  LabelListComponent,
  LabelRadioInputComponent,
  LabelStarRatingComponent,
  LabelTextareaComponent,
  PageNavigationComponent,
  SalaryInputComponent,
  SalaryRangeInputComponent,
  ScrollComponent,
  ValidationAlertComponent,
  WebsiteUserInputComponent,
];

/**
 * A module for widgets (@Components and @Directives) commonly used throughout the application.
 *
 *  Avoid putting services here, the {@link CoreModule} is more appropriate,
 * since all services in CoreModule are imported to AppModule as singletons
 * and won't break if lazy loading is implemented at some point.
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    TranslateModule,
    TextMaskModule,
    SharedModule,
  ],
  declarations: [
    ...COMPONENTS,
  ],
  exports: [
    ...COMPONENTS,
  ]
})
export class WidgetsModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: WidgetsModule,
      providers: [
        AlertService
      ]
    };
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/widgets/widgets.module.ts